import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaUser, FaRobot } from 'react-icons/fa';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const MessageContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.8rem;
  animation: ${fadeIn} 0.3s ease;
`;

const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${props => props.isUser ? '#3730A3' : '#ffd966'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.isUser ? 'white' : '#3730A3'};
  font-size: 0.7rem;
  flex-shrink: 0;
`;

const MessageBubble = styled.div`
font-family: 'Times New Roman', serif;
  max-width: 80%;
  background: ${props => props.isUser ? '#3730A3' : 'white'};
  color: ${props => props.isUser ? 'white' : '#1a1a2e'};
  padding: 0.6rem 0.8rem;
  border-radius: ${props => props.isUser ? '15px 15px 4px 15px' : '15px 15px 15px 4px'};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
  font-size: 0.85rem;
  line-height: 1.4;
  white-space: pre-line;
  border: ${props => !props.isUser && '1px solid rgba(55,48,163,0.08)'};
`;

const ChatMessage = ({ message, isUser }) => {
  return (
    <MessageContainer style={{ justifyContent: isUser ? 'flex-end' : 'flex-start' }}>
      {!isUser && (
        <Avatar isUser={false}>
          <FaRobot />
        </Avatar>
      )}
      <MessageBubble isUser={isUser}>
        {message}
      </MessageBubble>
      {isUser && (
        <Avatar isUser={true}>
          <FaUser />
        </Avatar>
      )}
    </MessageContainer>
  );
};

export default ChatMessage;